var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreatWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-bandage-white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bandage-white",
    clipPath: "url(#clip-bandage-white)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-bandage-90",
    transform: "translate(-0.034 89.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M32.8-57.2C6.8-31.2,7.1-31.7,11-24,14.9-16.4,24.5-9,30.5-9,34.1-9,81-56,81-59.6c0-5.9-7.5-15.6-15-19.4C58.3-82.9,58.8-83.2,32.8-57.2ZM59.5-66c0,1.8-.6,2.6-2.3,2.8-2.4.4-3.8-1.8-2.8-4.4a2.44,2.44,0,0,1,2.8-1.2C58.9-68.6,59.5-67.8,59.5-66Zm9,9c0,1.8-.6,2.6-2.3,2.8a2.44,2.44,0,0,1-2.8-1.2c-1-2.6.4-4.8,2.8-4.4C67.9-59.6,68.5-58.8,68.5-57ZM52.3-52.6C56-49.1,59-45.8,59-45.3c0,.4-3.1,4-7,7.8l-7,6.9-7-6.9c-3.8-3.8-7-7.4-7-7.8C31-46.4,44-59,45-59,45.4-59,48.7-56.1,52.3-52.6ZM26.5-33c0,1.8-.6,2.6-2.3,2.8a2.44,2.44,0,0,1-2.8-1.2c-1-2.6.4-4.8,2.8-4.4C25.9-35.6,26.5-34.8,26.5-33Zm9,9c0,1.8-.6,2.6-2.3,2.8a2.44,2.44,0,0,1-2.8-1.2c-1-2.6.4-4.8,2.8-4.4C34.9-26.6,35.5-25.8,35.5-24Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatWhite);
export default __webpack_public_path__ + "static/media/treat-white.0fabda6d4353efb840a862e64bab5be8.svg";
export { ForwardRef as ReactComponent };